export class PaymentReceivedDateSearchOption {

    constructor
        (
            public id: number,
            public name: string
        ) { }
}
